import initialState from 'src/modules/redux/initialState'
import actionTypes from 'src/modules/redux/actionTypes'

export const promoRequestReducer = (state = initialState.ads.promoRequest, action) => {
  switch (action.type) {
    case actionTypes.SET_ADS_PROMO_REQUEST:
      return action.payload
    default:
      return state
  }
}
